__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "agent-x";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@agentx/ui-components", "v2.00.08", () => (Promise.all([__webpack_require__.e(405), __webpack_require__.e(533), __webpack_require__.e(994), __webpack_require__.e(672), __webpack_require__.e(843), __webpack_require__.e(866), __webpack_require__.e(908)]).then(() => (() => (__webpack_require__(72929))))));
			register("@auth0/auth0-react", "2.15.1", () => (Promise.all([__webpack_require__.e(988), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(21988))))));
			register("@reduxjs/toolkit", "2.11.2", () => (Promise.all([__webpack_require__.e(934), __webpack_require__.e(414)]).then(() => (() => (__webpack_require__(54934))))));
			register("amazon-connect-streams", "2.25.1", () => (__webpack_require__.e(726).then(() => (() => (__webpack_require__(44726))))));
			register("axios", "1.13.6", () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(31914))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(976).then(() => (() => (__webpack_require__(64976))))));
			register("clsx", "2.1.1", () => (__webpack_require__.e(919).then(() => (() => (__webpack_require__(28919))))));
			register("dayjs", "1.11.20", () => (__webpack_require__.e(353).then(() => (() => (__webpack_require__(74353))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-bootstrap", "2.10.10", () => (Promise.all([__webpack_require__.e(335), __webpack_require__.e(502), __webpack_require__.e(533), __webpack_require__.e(672), __webpack_require__.e(232)]).then(() => (() => (__webpack_require__(82502))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(135), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(45135))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(666), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(76666))))));
			register("react-split", "2.0.14", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(71764))))));
			register("react-tabs", "6.1.0", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(843), __webpack_require__.e(161)]).then(() => (() => (__webpack_require__(98161))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(820), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(42488))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("redux-logger", "3.0.6", () => (__webpack_require__.e(448).then(() => (() => (__webpack_require__(79448))))));
			register("redux-thunk", "3.1.0", () => (__webpack_require__.e(825).then(() => (() => (__webpack_require__(20825))))));
			register("socket.io-client", "4.8.3", () => (__webpack_require__.e(661).then(() => (() => (__webpack_require__(17661))))));
			register("socket.io-react-hook", "2.4.5", () => (Promise.all([__webpack_require__.e(985), __webpack_require__.e(533), __webpack_require__.e(771)]).then(() => (() => (__webpack_require__(1985))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};